<!-- header start -->
<app-header-one [transparent]="true"></app-header-one>
<!-- header end -->

<main>

  <!-- breadcrumb start -->
  <app-breadcrumb-one title="Contact Us" subtitle="Contact"
    bg="/assets/img/page-title/page-title-2.jpg"></app-breadcrumb-one>
  <!-- breadcrumb end -->

  <!-- contact area start -->
  <section class="contact__area pb-100 pt-95">
      <div class="container">
          <div class="row">
              <div class="col-xl-6 col-lg-6">
                  <div class="contact__info">
                      <h3>Find us here.</h3>
                      <ul class="mb-55">
                          <li class="d-flex mb-35">
                              <div class="contact__info-icon mr-20">
                                  <i class="fal fa-map-marker-alt"></i>
                              </div>
                              <div class="contact__info-content">
                                  <h6>Address:</h6>
                                  <span>62, KANAKNIDHI, TIMALIYAWAD ROAD, NANPURA, Surat, Gujarat, 395001</span>
                              </div>
                          </li>
                          <li class="d-flex mb-35">
                              <div class="contact__info-icon mr-20">
                                  <i class="fal fa-envelope-open-text"></i>
                              </div>
                              <div class="contact__info-content">
                                  <h6>Email:</h6>
                                  <span><a href="mailto:itwalatechnologies@gmail.com">itwalatechnologies@gmail.com</a></span>
                              </div>
                          </li>
                          <li class="d-flex mb-35">
                              <div class="contact__info-icon mr-20">
                                  <i class="fal fa-phone-alt"></i>
                              </div>
                              <div class="contact__info-content">
                                  <h6>Number Phone:</h6>
                                  <span><a href="tel:09879962658">(+91) 98799 62658</a></span>
                              </div>
                          </li>
                      </ul>
                      <!-- <p>Outstock is a premium Templates theme with advanced admin module. It’s extremely customizable, easy to use and fully responsive and retina ready. Vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.</p> -->

                      <div class="contact__social">
                          <ul>
                              <li><a href="#"><i class="fab fa-dribbble"></i></a></li>
                              <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                              <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                              <li><a href="#"><i class="fab fa-behance"></i></a></li>
                              <li><a href="#"><i class="fas fa-share-alt"></i></a></li>
                          </ul>
                      </div>
                  </div>
              </div>
              <div class="col-xl-6 col-lg-6">
                  <div class="contact__form">
                      <h3>Contact Us.</h3>
                      <!-- contact form start -->
                      <app-contact-form></app-contact-form>
                      <!-- contact form end -->
                      <p class="ajax-response"></p>
                  </div>
              </div>
          </div>
      </div>
  </section>
  <!-- contact area end -->

  <!-- contact map area start -->
  <section class="contact__map">
      <div class="container-fluid p-0">
          <div class="row g-0">
              <div class="col-xl-12">
                  <div class="contact__map-wrapper p-relative">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14880.681506752238!2d72.8145529!3d21.1853897!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04e7b1ab86513%3A0x73489766e5d34139!2sI%20T%20Wala%20Technologies!5e0!3m2!1sen!2sin!4v1720460725358!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                  </div>
              </div>
          </div>
      </div>
  </section>
  <!-- contact map area end -->

  <!-- subscribe area start -->
  <app-subscribe-area></app-subscribe-area>
  <!-- subscribe area end -->

</main>

<!-- footer start -->
<app-footer-one></app-footer-one>
<!-- footer end -->
